"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactRadioButton = require("@adsk/alloy-react-radio-button");
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _alloyReactTooltip = require("@adsk/alloy-react-tooltip");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RadioButton = _ref => {
  let {
    disabled,
    value,
    label,
    info
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(RadioContainer, {
    "data-testid": "labelTemplate"
  }, /*#__PURE__*/_react.default.createElement(_alloyReactRadioButton.RadioButton, {
    disabled: disabled,
    value: value
  }), /*#__PURE__*/_react.default.createElement(Label, {
    disabled: disabled
  }, label), info && /*#__PURE__*/_react.default.createElement(StyledInfoPopover, {
    placement: "top",
    message: info
  }));
};
const RadioContainer = _styledComponents.default.label`
  align-items: center;
  display: flex;
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0px;
  }
  gap: 4px;
`;
const Label = (0, _styledComponents.default)(_styledComponents.default.span(_alloyReactTheme.default.typography.labelMedium))`
  padding-left: 8px;
  color: ${_ref2 => {
  let {
    disabled
  } = _ref2;
  return disabled ? _alloyReactTheme.default.colors.charcoal500 : _alloyReactTheme.default.colors.charcoal900;
}};
`;
const StyledInfoPopover = (0, _styledComponents.default)(_alloyReactTooltip.InfoPopover)`
  flex-shrink: 0;
  line-height: 0;
  color: ${_ref3 => {
  let {
    disabled
  } = _ref3;
  return disabled ? _alloyReactTheme.default.colors.charcoal500 : _alloyReactTheme.default.colors.charcoal900;
}};
`;
RadioButton.propTypes = {
  disabled: _propTypes.default.bool,
  value: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  info: _propTypes.default.string
};
var _default = exports.default = RadioButton;